<template>
    <div class="layout-inner" :class="[isCollapse ? 'collapse' : '', isMoile ? 'mobile': '']">
        <!-- <div class="layout-mask" v-if="showMobileMenu" @click="showMobileMenu=false"></div> -->
        <!-- 右侧菜单栏开始 -->
        <div class="layout-sidenav" :class="showMobileMenu?'show':''" @click="showMobileMenu=false">
            <div class="cp-logo"></div>
            <slideMenu :menu="routes" :collapse="isCollapse"/>
            <i class="sidenav-btn" @click="isCollapse = !isCollapse"></i>
        </div>
        <!-- 右侧菜单栏结束 -->
        <div class="layout-right">
            <GlobalHeader @showMenu="showMobileMenu=true"></GlobalHeader>
            <div class="layout-container">
                <slot/>
            </div>
            <div class="layout-footer"></div>
        </div>
    </div>
</template>

<script>
import { asyncRouterMap } from '@/router/router'
import GlobalHeader from './GlobalHeader'
import slideMenu from '@/components/menu/'
export default {
    components: {
        slideMenu,
        GlobalHeader
    },
    data () {
        return {
            isCollapse: false,
            showMobileMenu: false,
            routes: asyncRouterMap[0]['children']
        }
    },
    computed: {
        isMoile () {
            return this.$store.state.app.device === 'mobile'
        },
        siderBar () {
            return this.$store.state.app.sidebar
        }
    },
    watch: {
        siderBar (value) {
            this.isCollapse = value
            this.showMobileMenu = false
        }
    }
}
</script>
<style lang="less">
.layout-inner {
    height: 100%;
    .layout-mask {
        top: 0;
        left: 0;
        width: 100%;
        z-index: 98;
        height: 100%;
        display: none;
        position: fixed;
        background: rgba(0, 0, 0, .3)
    }
    .layout-head {
        position: fixed;
        height: 70px;
        left: 260px;
        right: 0;
        z-index: 90;
        box-shadow: 0 1px 10px rgba(0,21,41,.08);
        display: flex;
        justify-content: space-between;
    }
    .layout-sidenav {
        position: fixed;
        z-index: 99;
        top: 0;
        bottom: 0px;
        width: 260px;
        left: 0;
        background: #23253a;
        color: #b9bde8;
        .el-menu-item i, .el-submenu__title i {
            color: inherit;
        }
        .sidenav-btn {
            background: #23253a;
            top: 50%;
            right: 0;
            height: 100px;
            margin-top: -60px;
            margin-right: -10px;
            width: 20px;
            position: absolute;
            cursor: pointer;
            border-radius: 30px;
            transition: 1s;
            &:hover {
                background: #0d161d;
            }
        }
    }
    .layout-right {
        position: relative;
        margin-left:260px;
    }
    .layout-footer {
        bottom: 0px;
        right: 0px;
        height: 50px;
    }
    .layout-container {
        padding-top: 70px;
    }
    .scee {
        width: 260px;
        height: 70px;
    }
    .el-menu {
        border: none;
    }
    &.collapse {
        .layout-sidenav {
            width: 64px;
        }
        .layout-right {
            margin-left: 64px;
        }
        .layout-head {
            left: 64px;
        }
    }
    &.mobile {
        .layout-head {
            left: 0;
        }
        .layout-mask {
            display: block;
        }
        .layout-sidenav {
            transform: translateX(-100%);
            transition: 300ms;
            &.show {
                transform: translateX(0);
            }
            .sidenav-btn {
                display: none;
            }
        }
        .layout-right {
            margin-left: 0;
        }
    }
}
.bg-dark {
    color: #7793a7;
    background-color: #1c2b36;
}
.bg-white {
    color: #666;
    background-color: #fff;
}
.p20 {
    padding: 20px;
}
.head-left-box {
    display: flex;
    align-items: center;
    .mobile-cd {
        line-height: 70px;
        padding: 0 15px;
        transition: 1s;
        font-size: 18px;
    }
}
.head-right-box {
    display: flex;
    align-items: center;
    .head-icon {
        line-height: 70px;
        padding: 0 15px;
        transition: 1s;
        font-size: 18px;
        cursor: pointer;
        &:hover {
            background: rgba(0,0,0,.05);
        }
    }
}
.cp-logo {
    height: 70px;
    // background-color: #1f2134;
}
.user-info {
    display: flex;
    align-items: center;
    padding: 15px 10px 15px;
    margin-right: 10px;
    cursor: pointer;
    img {
        display: flex;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .user-info-text {
        line-height: 1;
        h4 {
            font-size: 16px;
        }
        p {
            margin-top: 5px;
            font-size: 12px;
        }
    }
    &:hover {
        background: rgba(0,0,0,.025);
    }
}
</style>
